<section class="main-wrap inner-views dashboard-wrap benefits-wrap" [ngClass]="{ 'menu-open in': !toggleClass }">
  <div class="inner-benefits" [class.activeH]="btnClick[0]">
    <nav class="navbar navbar-expand-lg" id="desk-top-nav">
      <app-user-menu></app-user-menu>
      <div class="button-box">
        <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false">
          <span class="sr-only">Toggle Dropdown</span>
          <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
        </button>
        <div class="dropdown-menu">
          <app-menu></app-menu>
          <app-menu-alt></app-menu-alt>
        </div>
      </div>
    </nav>

    <div class="container-wrap" [class.activeUe]="btnClick[1]">
      <div class="heading-container sidebar-container" id="menu">
        <div class="row">
          <div class="col">
            <app-logo></app-logo>
            <div class="button-box">
              <button class="btn btn-sm-menu" type="button" (click)="toggleClass = !toggleClass">
                <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
              </button>
            </div>
            <app-header></app-header>
          </div>
        </div>
      </div>

      <div class="content-container login-container dash-container benefits-container" [class.activeLe]="btnClick[2]">
        <div class="row happy-man-box" [class.activeTorso]="btnClick[3]">
          <div class="col-md-12 dash-title">
            <h1>Benefits Portal</h1>
          </div>
          <div class="clearfix"></div>
          <div class="col-md-3">
            <div class="shop-tile benefits-tile-check card-margin">
              <div class="check-in default-check">
                <h3>Checklist</h3>
                <p>Select a highlighted area for benefit details</p>
              </div>
              <div class="check-in check-head">
                <h3>Checklist:<br>
                Head</h3>
                <a class="tile-link back-to-full" href="javascript:void(0);" (click)="toggleA(0)">Go Back to Full Body
                View</a>
                <ul class="body-check">
                  <li><strong class="check-name">Safety Glasses</strong>
                  <strong class="complete">Complete <img src="assets/images/icons/check-circle-58x58.svg" width="20"
                  height="20" alt="Check Circle" /></strong>
                </li>
                <!-- <li><strong class="check-name">Ear Protection</strong>
                <strong class="complete">Complete <img src="assets/images/icons/check-circle-58x58.svg" width="20" height="20" alt="Check Complete"/></strong></li> -->
              </ul>
            </div>
            <div class="check-in check-upper">
              <h3>Checklist:<br>
              Upper Extremities</h3>
              <a class="tile-link back-to-full" href="javascript:void(0);" (click)="toggleA(1)">Go Back to Full Body
              View</a>
              <ul class="body-check">
                <li><strong class="check-name">Shoulder Pads</strong>
                <strong class="complete">Complete <img src="assets/images/icons/check-circle-58x58.svg" width="20"
                height="20" alt="Shoulder Pads Check" /></strong>
              </li>
              <li><strong class="check-name">Gloves</strong>
              <strong class="needs-attention">Still Needed <img src="assets/images/benefits/info-circle-57x57.svg"
              width="20" height="20" alt="Gloves Check" /></strong>
            </li>
          </ul>
        </div>
        <div class="check-in check-lower">
          <h3>Checklist:<br>
          Lower Extremities</h3>
          <a class="tile-link back-to-full" href="javascript:void(0);" (click)="toggleA(2)">Go Back to Full Body
          View</a>
          <ul class="body-check">
            <!--    <li><strong class="check-name">Lower One</strong>
            <strong class="complete">Complete <img src="assets/images/icons/check-circle-58x58.svg" width="20" height="20" alt="Shoulder Pads Check"/></strong></li> -->
            <li><strong class="check-name">Footwear</strong>
            <strong class="needs-attention">Still Needed <img src="assets/images/benefits/info-circle-57x57.svg"
            width="20" height="20" alt="Footwear Check" /></strong>
          </li>
        </ul>
      </div>
      <div class="check-in check-torso">
        <h3>Checklist:<br>
        Torso</h3>
        <a class="tile-link back-to-full" href="javascript:void(0);" (click)="toggleA(3)">Go Back to Full Body
        View</a>
        <ul class="body-check">
          <li><strong class="check-name">Torso One</strong>
          <strong class="complete">Complete <img src="assets/images/icons/check-circle-58x58.svg" width="20"
          height="20" alt="Shoulder Pads Check" /></strong>
        </li>
        <li><strong class="check-name">Torso Two</strong>
        <strong class="needs-attention">Still Needed <img src="assets/images/benefits/info-circle-57x57.svg"
        width="20" height="20" alt="Gloves Check" /></strong>
      </li>
    </ul>
  </div>
</div>
@if (hasRecommendations) {
  <div class="shop-tile benefits-tile-check card-margin">
    <h3>Recommended</h3>
    <ul>
      @if (prescription) {
        <li>
          <span>Prescription:</span>
          @if (!prescription.isExpired) {
            <span
              [ngClass]="[prescription.isValid ? 'complete' : 'incomplete']">{{ prescription.isValid ?
            'Complete' : 'Incomplete' }}</span>
          }
          @if (prescription.isExpired) {
            <span class="incomplete text-red" placement="top"
              [ngbPopover]="prescription.prescriptionExpiration | date">
              Expired <img src="assets/images/benefits/info-circle-red-57x57.svg" style="height:18px" />
            </span>
          }
        </li>
      }
      <!-- <li><span>Eye Exam:</span> <span class="complete">Complete</span></li> -->
    </ul>
  </div>
}
<div class="shop-tile benefits-tile-check card-margin">
  <h3>Services</h3>
  @if (hearingExam || visionExam) {
    <div>
      @if (visionExam != null) {
        <div>
          <p class="exam-type">Vision Exam</p>
          <p class="exam-date">Exam Date: {{visionExam.dateAdded | date :'shortDate'}}</p>
          <p>
            Exam ID:
            <span class="dead-link" (click)="showExam(visionExam)">
              {{visionExam.examId}}
            </span>
          </p>
        </div>
      }
      @if (hearingExam != null && visionExam != null) {
        <hr />
      }
      @if (hearingExam != null) {
        <div>
          <p class="exam-type">Hearing Exam</p>
          <p class="exam-date">Exam Date: {{hearingExam.dateAdded | date :'shortDate'}}</p>
          <p>
            Exam ID:
            <span class="dead-link" (click)="showExam(hearingExam)">
              {{hearingExam.examId}}
            </span>
          </p>
        </div>
      }
    </div>
  }
  @if (!hearingExam && !visionExam) {
    <div>
      No exams available.
    </div>
  }
</div>
</div>
<div class="col-md-6 happy-man-col">
  <div class="head-box">
    <!-- EAR -->
    <!-- <span class="circle-over completed"></span> -->
    <img src="assets/images/benefits/happy-man-head-thin.svg" width="200" alt="Happy Man Head Icon" />
    <!-- GLASSES OR EYEWEAR -->
    <span class="circle-over completed"></span>
  </div>
  <!--  <div class="ue-box">
  <span class="circle-over completed"></span>
  <img src="assets/images/benefits/happy-man-upper-extremities-thin.svg" width="200" alt="Happy Man Upper Extremities Icon"/>
  <span class="circle-over incomplete"></span>
</div> -->
<div class="le-box">
  <!-- <span class="circle-over completed"></span> -->
  <img src="assets/images/benefits/happy-man-lower-extremities-thin.svg" width="200"
    alt="Happy Man Lower Extremities Icon" />
  <!-- FOOTWEAR -->
  <span class="circle-over incomplete"></span>
</div><!--
<div class="torso-box">
  <span class="circle-over completed"></span>
  <img src="assets/images/benefits/happy-man-torso-thin.svg" width="200" alt="Happy Man Torso Icon"/>
  <span class="circle-over incomplete"></span>
</div> -->
<div class="full-body-wrap">
  <button class="body-btn head completed-btn" role="button" (click)="toggleA(0)">
    <img src="assets/images/benefits/check-circle-58x58.svg" width="25" height="25" alt="Check Icon" />
  </button>
  <!-- <button class="body-btn upper-e attention-btn" role="button" (click)="toggleA(1)">
  <img src="assets/images/benefits/happy-man-blue-circle.svg" width="25" height="25" alt="Happy Man Blue Icon"/>
</button> -->
<!-- <button class="body-btn torso info-btn" role="button" disabled (click)="toggleA(3)">
<img src="assets/images/benefits/happy-man-notapplicable-circle.svg" width="25" height="25" alt="Happy Man Not Applicable Icon"/>
</button> -->
<button class="body-btn lower-e attention-btn" role="button" (click)="toggleA(2)">
  <img src="assets/images/benefits/happy-man-blue-circle.svg" width="25" height="25"
    alt="Happy Man Circle Icon" />
</button>
<img src="assets/images/benefits/happy-man-full-body.svg" width="200" height="600"
  alt="Happy Man Full Body" />

</div>
</div>
<div class="clearfix"></div>
</div>
<div class="row benefits-row">
  <div class="col-md-12 dash-title benefits-request-title">
    <h2>Benefits Breakdown</h2>
  </div>
  <div class="clearfix"></div>
  @for (benefit of benefits; track $index; let i = $index) {
    @if (i % 2 == 0) {
      <div class="row benefits-breakdown-container">
        @for (benefitRow of benefits?.slice(i, i + 2); track $index; let k = $index) {
          <div
            [ngClass]="k == 0 ?'row-one' : ''" class="col-md-6 benefits-breakdown"
            [class.activeBenefit]="benefitView[k + i]">
            <div class="benefits-tile">
              <h3>{{benefitRow.category}}</h3>
              <p class="benefits-description">{{benefitRow.benefitDescription}}</p>
              <button [disabled]="benefitRow.benefitItems.length == 0" class="body-btn more-details" role="button"
                (click)="toggleBenefitView(k + i)">
                <span>
                  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 56.73 56.73" class="info-circle-svg">
                    <defs></defs>
                    <path id="info-circle"
                      d="M30.11,2A28.37,28.37,0,1,0,58.48,30.36,28.36,28.36,0,0,0,30.11,2Zm0,12.58a4.81,4.81,0,1,1-4.8,4.8,4.8,4.8,0,0,1,4.8-4.8Zm6.41,29.05A1.37,1.37,0,0,1,35.15,45H25.08a1.37,1.37,0,0,1-1.37-1.37V40.89a1.37,1.37,0,0,1,1.37-1.38h1.38V32.19H25.08a1.37,1.37,0,0,1-1.37-1.37V28.08a1.37,1.37,0,0,1,1.37-1.38H32.4a1.37,1.37,0,0,1,1.37,1.38V39.51h1.38a1.37,1.37,0,0,1,1.37,1.38Z"
                      transform="translate(-1.75 -2)" />
                  </svg>
                  More Details
                </span>
              </button>
            </div>
            <div class="benefits-tile-data">
              <p>Renews
                <span class="text-lime-green app-renews-date">{{benefitRow.renewalDate | date:
                'MM/dd/YYYY'}}</span>
              </p>
              <a class="tile-link" [routerLink]="benefitRow.category | moduleLink">Shop Now</a>
            </div>
            <div class="inner-popup">
              <a class="tile-link back-to-full" href="javascript:void(0);"
              (click)="toggleBenefitView(k + i)">X</a>
              @for (benefitItems of benefitRow.benefitItems; track $index) {
                <div class="col-md-12 dash-title-pop">
                  <h3 class="item-name">{{benefitItems.itemCategory}}</h3>
                </div>
                @if (!benefitRow.isFullCarryOverBenefit && benefitItems.carryOverDetails) {
                  <div
                    class="alert alert-info">
                    <strong><i class="fa fa-fw fa-info-circle"></i></strong>
                    This is a carry over benefit item. The current amount left over is
                    <b>{{benefitItems.carryOverDetails.amountLeftOver}}</b>.
                    Amount left over will expire on : <b>{{benefitItems.carryOverDetails.expirationDate}}</b>
                  </div>
                }
                <div class="clearfix"></div>
                <div class="col-md-12 table-items">
                  @if (!benefitItems.isNotForSale && !benefitItems.hasNoBenefit) {
                    <table>
                      <thead>
                        <tr>
                          <th scope="col">Item</th>
                          <th scope="col">Coverage</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (itemDetail of benefitItems.coveredItems; track $index; let i = $index) {
                          <tr>
                            <td>{{itemDetail.itemDescription}}</td>
                            <td>{{itemDetail.coverageDescription}}</td>
                          </tr>
                        }
                        <tr>
                          <td data-label="Item"></td>
                          <td data-label="Coverage"></td>
                        </tr>
                      </tbody>
                    </table>
                  } @else {
                    @if (benefitItems.hasNoBenefit) {
                      <div class="alert alert-warning">
                        <strong><i class="fa fa-fw fa-info-exclamation"></i></strong>
                        No benefit.
                      </div>
                    }
                    @if (benefitItems.isNotForSale) {
                      <div class="alert alert-info">
                        <strong><i class="fa fa-fw fa-info-circle"></i></strong>
                        This item is not available through your company.
                      </div>
                    }
                  }
                </div>
                @if (benefitItems.notCoveredItems && !benefitItems.hasNoBenefit) {
                  <div
                    class="col-md-12 col-not-covered">
                    <h4>Items Not Covered</h4>
                    @for (itemDetail of benefitItems.notCoveredItems; track $index) {
                      <p>{{itemDetail}}</p>
                    }
                  </div>
                }
              }
            </div>
          </div>
        }
      </div>
    }
  }

  <!--               <div class="clearfix"></div>

  <div class="col-md-12 dash-title benefits-request-title">
    <h2>Benefits Request</h2>
  </div>

  <div class="col-md-12 benefits-tile">
    <div class="benefits-tile-in">
      <h3>Safety Eyewear Benefits Request - <span class="benefits-request-date">12/20/2021</span></h3>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas a nibh vel eros facilisis gravida non eget neque. Quisque ac est at tellus euismod convallis. Suspendisse potenti.</p>


      <div class="show-more">
        <p>
          <button class="btn gray-btn" type="button" data-toggle="collapse" data-target="#showMore" aria-expanded="false" aria-controls="showMore">
            Show Previous Requests
          </button>
        </p>
        <div class="collapse" id="showMore">
          <div class="card card-body">
            <div class="request-one">
              <h3>Safety Eyewear Benefits Request - <span class="benefits-request-date">12/20/2021</span></h3>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas a nibh vel eros facilisis gravida non eget neque.
              Quisque ac est at tellus euismod convallis. Suspendisse potenti.</p>
            </div>

            <div class="request-two">
              <h3>Safety Eyewear Benefits Request - <span class="benefits-request-date">12/20/2021</span></h3>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas a nibh vel eros facilisis gravida non eget neque.
              Quisque ac est at tellus euismod convallis. Suspendisse potenti.</p>
            </div>

            <div class="request-three">
              <h3>Safety Eyewear Benefits Request - <span class="benefits-request-date">12/20/2021</span></h3>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas a nibh vel eros facilisis gravida non eget neque.
              Quisque ac est at tellus euismod convallis. Suspendisse potenti.</p>
            </div>
          </div>
        </div>
      </div>

    </div>

    <a data-toggle="modal" data-target="#rf-popup" href="#" class="request-form-popup btn benefits-request-btn gray-btn">Submit Question</a>
    <button class="btn benefits-request-btn gray-btn"> Submit Question </button> -->

  <!--           </div>

  <div class="clearfix"></div>

  <div class="col-md-12 dash-title benefits-request-title">
    <h2>Safety Training</h2>
  </div>

  <div class="clearfix"></div>

  <div class="row benefits-flex">

    <div class="col-md-3">
      <div class="shop-tile">
        <h3>Operator Training</h3>
        <p class="text-center">
          Please watch the required videos within this module.
        </p>
        <p class="button-box"><a class="gray-btn" href="#">Go to Module</a></p>
        <p class="test-status">Status: <span class="complete">Complete</span></p>
      </div>
    </div>

    <div class="col-md-3">
      <div class="shop-tile">
        <h3>Operator Test</h3>
        <p class="text-center">
          Please take the following test to complete training.
        </p>
        <p class="button-box"><a class="gray-btn" href="#">Go to Test</a></p>
        <p class="test-status">Status: <span class="complete">Complete</span></p>
      </div>
    </div>
  </div>

</div>
</div>
</div>
</div> -->


<!--   <div class="modal fade" id="rf-popup" data-backdrop="static" data-keyboard="false" tabindex="-1"
aria-labelledby="request-popup" aria-hidden="true" style="display: none;">
<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">

      <div class="form-wrap inner-forms">
        <form action="#">
          <div class="formField emailinput">
            <label for="email">Email Address</label>
            <input id="email" placeholder="Enter Email Address" type="email">
          </div>
          <div class="formField userinput">
            <label for="userName">Username</label>
            <input id="userName" placeholder="Enter Username" type="text">
          </div>
          <div class="formField passInput">
            <label for="userMessage">Your Request</label>
            <textarea id="userMessage" placeholder="Your Request" name="request"></textarea>
          </div>

          <div class="formField submitInput">
            <input class="form-submit gray-btn" type="button" value="Submit">
          </div>
        </form>
      </div> !-->

    </div>
  </div>
</div>
</div>
</section>
